import * as $ from 'jquery';
import ScrollPositionController from './ScrollPositionController';

export default class ProductNavigationController {
  private $hamburgerSelector = $('.js-btnProductSubmenu');
  private $hamburgerNavigation = this.$hamburgerSelector;

  constructor() {
    new ScrollPositionController();
    this.$hamburgerNavigation.on('click', this.toggleMenu);
  }

  toggleMenu() {
    const navigationtoggle = document.getElementsByClassName('js-navigationProductSubmenuContainer')[0];
    const hamburger = document.getElementsByClassName('js-btnProductSubmenu')[0];
    hamburger.classList.toggle('active');
    navigationtoggle.classList.toggle('nav--open');
  }
}
